import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../Pages/Config"; // adjust path if needed

const BuyerNameRewview = ({ buyerId }) => {
  const [name, setName] = useState("Loading...");

  useEffect(() => {
    const fetchBuyer = async () => {
      try {
        const res = await axios.get(
          `${BASE_URL}/get_user_by_id.php?id=${buyerId}&t=${Date.now()}`
        );
        if (res.data.success && res.data.data && res.data.data.name) {
          setName(res.data.data.name); // or use res.data.data.username
        } else {
          setName("Unknown Buyer");
        }
      } catch (error) {
        console.error("Failed to fetch buyer", error);
        setName("Error");
      }
    };

    if (buyerId) {
      fetchBuyer();
    }
  }, [buyerId]);

  return <p style={{ fontSize: "13px", margin: "0" }}> {name}</p>;
};

export default BuyerNameRewview;
